import { CSSProperties } from "react"
import { Column } from "@tanstack/react-table"
import { TheasoftColumnDef } from "./types"

function getColumnId<TData>(column: TheasoftColumnDef<TData>) {
  return column.id ?? (column as { accessorKey?: string }).accessorKey
}

export function getDefaultColumnOrder<TData>(
  columnDefinitions: TheasoftColumnDef<TData>[]
) {
  return columnDefinitions
    .map((column) => getColumnId(column))
    .filter((id): id is string => !!id)
}

export function getExplicitlySizedColumnIds<TData>(
  columnDefinitions: TheasoftColumnDef<TData>[]
) {
  const ids = new Set<string>()

  columnDefinitions.forEach((column) => {
    if (typeof (column as { size?: number }).size !== "number") {
      return
    }

    const id = getColumnId(column)
    if (id) {
      ids.add(id)
    }
  })

  return ids
}

export function getColumnWidthStyles<TData>(
  column: Column<TData, unknown>,
  shouldUseFixedColumnWidth: boolean
): CSSProperties {
  if (shouldUseFixedColumnWidth) {
    const width = column.getSize()
    return {
      width,
      flex: `0 0 ${width}px`,
    }
  }

  // Match default table behavior for unsized columns when resizing is disabled.
  return {
    width: 0,
    flex: "1 1 0px",
  }
}
